import { createSelector } from '@ngrx/store';
import { DailyLeadLegacyState } from './daily-lead.reducer';

const selectDailyLeadLegacyState = (state: any) => state.dailyLeadLegacy;

export const selectDailyLeads = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.leads ?? []
);

export const selectSelectedLead = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.selectedLead ?? null
);

export const selectDailyLeadLoading = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.loading ?? false
);

export const selectDailyLeadDetailLoading = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.detailLoading ?? false
);

export const selectDailyLeadError = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.error ?? null
);

export const selectDailyLeadMeta = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.meta ?? null
);

export const selectDailyLeadGenerating = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.generating ?? false
);

export const selectDailyLeadGenerateMessage = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.generateMessage ?? null
);

export const selectDailyLeadEstimatedLeads = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.estimatedLeads ?? null
);

export const selectDailyLeadRuns = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.runs ?? []
);

export const selectDailyLeadRunsLoading = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.runsLoading ?? false
);

export const selectDailyLeadRunsMeta = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.runsMeta ?? null
);

export const selectNotifications = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.notifications ?? []
);

export const selectNotificationsLoading = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.notificationsLoading ?? false
);

export const selectNotificationsMeta = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.notificationsMeta ?? null
);

export const selectNotificationsUnreadCount = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.notificationsUnreadCount ?? 0
);

export const selectMarkingAllRead = createSelector(
  selectDailyLeadLegacyState,
  (state: DailyLeadLegacyState) => state?.markingAllRead ?? false
);
